import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "right" }

import UserVipInfoBtn from "@/components/Dialogues/Chat/UserVipInfoBtn.vue";
import { isCompactMode } from "@/data/pubilc";
import { isExpand } from "@/views/Home/useData/useHomePage";

import {
  dialogueStatus,
  dialogueList,
  init,
  addDialogue,
} from "@/views/Home/useData/module/dialogue";
import { openLoginDialog } from "@/components/Dialogues/useData/login";
import { ElMessage } from "element-plus";
import { computed } from "vue";
import { chatStatus } from "@/views/Home/useData/module/chat";
import { storeToRefs } from "pinia";
import publicStore from "@/store/publicStore";


export default /*@__PURE__*/_defineComponent({
  __name: 'ChatHeader',
  setup(__props) {

const isReplying = computed(() => {
  return chatStatus.isReplying;
});
const { isLogin } = storeToRefs(publicStore());

const addNewDialogue = () => {
  if (!isLogin.value) {
    return openLoginDialog();
  }

  if (isReplying.value) {
    return ElMessage({
      message: "当前对话正在进行中，请先结束当前对话",
      type: "warning",
      duration: 1000,
    });
  }
  addDialogue();
};

return (_ctx: any,_cache: any) => {
  const _component_Expand = _resolveComponent("Expand")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_ChatLineSquare = _resolveComponent("ChatLineSquare")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["header", { 'compact-header': _unref(isCompactMode) }])
  }, [
    (_unref(isCompactMode))
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "expand-btn",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (isExpand.value = !_unref(isExpand)))
        }, [
          _createVNode(_component_el_icon, { size: "20" }, {
            default: _withCtx(() => [
              _createVNode(_component_Expand)
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      (_unref(isCompactMode))
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "btn",
            onClick: addNewDialogue
          }, [
            _createVNode(_component_el_icon, {
              size: 20,
              color: `#000`
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ChatLineSquare)
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      _createVNode(UserVipInfoBtn)
    ])
  ], 2))
}
}

})